import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../../commonComponents/forms/inputs/Select';

export default function SectionFilter({ id, value, items, onChange }) {
  return (
    <div className="m-portlet__head-tools">
      <div className="m-form">
        <div className="m-form__group m-form__group--inline">
          <div className="m-form__control" style={{ minWidth: '200px' }}>
            <Select
              className="form-control"
              id={id}
              items={items}
              value={value}
              onChange={onChange}
              searchable={items.length > 6}
            />
          </div>
          <div className="d-md-none m--margin-bottom-10" />
        </div>
      </div>
    </div>
  );
}

SectionFilter.propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, text: PropTypes.string }),
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
